import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import packageJson from '../../../../../package.json';
import { LogoutMenuItem } from './menu-user-button-item/logout-menu-item/logout-menu-item';
import { UserManagementMenuItem } from './menu-user-button-item/user-management-menu-item/user-management-menu-item';

@Component({
  selector: 'app-menu-user',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    LogoutMenuItem,
    UserManagementMenuItem,
  ],
  templateUrl: './menu-user.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./menu-user.component.scss'],
})
export class MenuUserComponent {
  userName = input('');
  version = packageJson.version;
}
